import FooterSelector from "./FooterSelector";
export default FooterSelector;
